import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import PermissionsGate from "@/Shared/PermissionsGate";
import {useDispatch} from "react-redux";
import {openModal} from "@/Store/Slices/ModalSlice";
import {Inertia} from "@inertiajs/inertia";

const AddedMerchantActionBtns = ({link, id, isLive}) => {
  const dispatch = useDispatch();

  const handlePublished = () => {
    dispatch(openModal({
        modalType: 'merchant-publication',
        modalProps: {
          id: id
        }
      }
    ));
  }

  const handleDelete = () => {
    if (confirm('Are you sure you want to delete this merchant?')) {
      Inertia.delete(route('added.merchants.destroy', id));
    }
  }

  return (
    <div className='flex'>
      <a target='_blank' className={'mr-3'} id="tooltip" data-tip="Go to the store site" href={link}>
        <FontAwesomeIcon
          color={'blue'}
          size={'lg'}
          icon={solid('arrow-up-right-from-square')}/>
      </a>
      {
        !isLive && (
          <PermissionsGate scopes={['public-merchant']}>
            <button onClick={handlePublished} className={'mr-3'} id="tooltip" data-tip="Publish merchant">
              <FontAwesomeIcon
                color={'green'}
                size={'lg'}
                icon={solid('arrow-right-long')}/>
            </button>
          </PermissionsGate>
        )
      }
        <button data-tip="Remove merchant" onClick={handleDelete}>
          <FontAwesomeIcon
            color={'red'}
            size={'lg'}
            icon={solid('xmark')}/>
        </button>
    </div>
  );
};

export default AddedMerchantActionBtns;
